import { GlobalManager } from './GlobalManager';
const globalManager = new GlobalManager();

/**
 * Helper class that can be inherited from to store a reference to the GlobalManager and
 * provide convenience methods to the global objects managed by the GlobalManager.
 */
export class GlobalManagerProvider {
  setGlobalManager(globalManager) {
    this.globalManager = globalManager;
    this.onSetGlobalManager(this.globalManager);
  }

  /**
   * Classes can override this method to pass the instance to other objects
   * See DockingPanel.js for an example
   * @param {GlobalManager} globalManager GlobalManager instance
   */
  // eslint-disable-next-line no-unused-vars
  onSetGlobalManager(globalManager) {

    // To be overridden
  }
  getWindow() {
    return this.globalManager.getWindow();
  }

  getDocument() {
    return this.globalManager.getDocument();
  }

  setWindow(newWindow) {
    return this.globalManager.setWindow(newWindow);
  }

  addWindowEventListener(type, listener, ...options) {
    this.globalManager.addWindowEventListener(type, listener, ...options);
  }

  removeWindowEventListener(type, listener, ...options) {
    this.globalManager.removeWindowEventListener(type, listener, ...options);
  }

  addDocumentEventListener(type, listener, ...options) {
    this.globalManager.addDocumentEventListener(type, listener, ...options);
  }

  removeDocumentEventListener(type, listener, ...options) {
    this.globalManager.removeDocumentEventListener(type, listener, ...options);
  }
}

GlobalManagerProvider.prototype.globalManager = globalManager;


/**
 * Adds the GlobalManagerProvider methods to the prototype of another class.
 *
 * This function can be used to add the GlobalManagerProvider functionality to a
 * class without directly inheriting from the GlobalManagerProvider class. The downside will
 * be that there will not be correct type information for the globalManager property.
 *
 * It is mainly provided for backwards compatibility because this pattern is used in all
 * existing extensions. Where possible, prefer to inherit from the GlobalManagerProvider class.
 */
export function GlobalManagerMixin() {
  this.globalManager = GlobalManagerProvider.prototype.globalManager;
  this.setGlobalManager = GlobalManagerProvider.prototype.setGlobalManager;
  this.onSetGlobalManager = GlobalManagerProvider.prototype.onSetGlobalManager;
  this.getWindow = GlobalManagerProvider.prototype.getWindow;
  this.getDocument = GlobalManagerProvider.prototype.getDocument;
  this.setWindow = GlobalManagerProvider.prototype.setWindow;
  this.addWindowEventListener = GlobalManagerProvider.prototype.addWindowEventListener;
  this.removeWindowEventListener = GlobalManagerProvider.prototype.removeWindowEventListener;
  this.addDocumentEventListener = GlobalManagerProvider.prototype.addDocumentEventListener;
  this.removeDocumentEventListener = GlobalManagerProvider.prototype.removeDocumentEventListener;
}

// This is a workaround to solve the problem, that the GlobalManagerMixing/GlobalManagerProvider is already imported via the
// namespace in some extenstions that are also imported via import statements into the bundle. The problem
// is that the namespaces are only filled once the whole bundle has been parsed and thus while code within
// the bundle is executed it is not yet possible to get the symbols from the global namespace.
// We use the IIFE here to hide this assignment from the TypeScript compiler. The types will be correctly
// assigned because we are exporting the GlobalManagerMixin function.
(function () {
  globalThis.Autodesk.Viewing.GlobalManagerMixin = GlobalManagerMixin;
  globalThis.Autodesk.Viewing.GlobalManagerProvider = GlobalManagerProvider;
})();